<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Persona Info"
    seFeDataSubtitle="A form to collect minimal info about a profile for an account"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div>
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this component when adding a child sub-profile to an account</p>
        </se-fe-card-content>
      </se-fe-card>

      @for (n of models; track n) {
        <se-fe-card>
          <se-fe-card-header [seFeDataTitle]="n"></se-fe-card-header>
          <se-fe-card-content>
            <se-fe-docs-table
              [seFeDataHeaders]="headers[n]"
              [seFeDataRows]="rows[n]">
            </se-fe-docs-table>
          </se-fe-card-content>
        </se-fe-card>
      }

      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-persona-info-example></se-po-persona-info-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
<se-fe-toast></se-fe-toast>
